/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Coverfithint2Inputs */

const en_coverfithint2 = /** @type {(inputs: Coverfithint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your cover does not fit the landscape format. AI rearranges text, logo and people so nothing gets cut off. Cost: ${i?.credits} credits`)
};

const de_coverfithint2 = /** @type {(inputs: Coverfithint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Titelbild passt nicht ins Querformat. Die KI ordnet Text, Logo und Personen neu an, damit nichts abgeschnitten wird. Kosten: ${i?.credits} Credits`)
};

/**
* | output |
* | --- |
* | "Your cover does not fit the landscape format. AI rearranges text, logo and people so nothing gets cut off. Cost: {credits} credits" |
*
* @param {Coverfithint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfithint2 = /** @type {((inputs: Coverfithint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfithint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfithint2(inputs)
	return de_coverfithint2(inputs)
});
export { coverfithint2 as "coverFitHint" }